import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const MainLayout = ({ 
  children, 
  onCategorySelect, 
  onSearchChange, 
  onCartOpen, 
  onWishlistOpen, 
  onDebug 
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header 
        onCategorySelect={onCategorySelect}
        onSearchChange={onSearchChange}
        onCartOpen={onCartOpen}
        onWishlistOpen={onWishlistOpen}
        onDebug={onDebug}
      />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
